import apiClient from '../apiClient';
import { PUT_MASTER_REFERENCE_URL } from '../apiUrl';

const putMasterDataReferenceApi = (param, id, data) => {
  return apiClient.put(PUT_MASTER_REFERENCE_URL(param, id), data);
};

export default putMasterDataReferenceApi;
